const searchLogPerformanceConstants = {
  EXP_SEARCH_LOAD_START: "expSearchLogPerformanceApp/LOAD_SART",
  EXP_SEARCH_MAIN_FUNCTIONALITY: "expSearchLogPerformanceApp/MAIN_FUNCTIONALITY",
  EXP_SEARCH_FULL_LOAD: "expSearchLogPerformanceApp/FULL_LOAD",
  FLIGHT_SEARCH_LOAD_START: "fltSearchLogPerformanceApp/LOAD_SART",
  FLIGHT_SEARCH_MAIN_FUNCTIONALITY: "fltSearchLogPerformanceApp/MAIN_FUNCTIONALITY",
  FLIGHT_SEARCH_FULL_LOAD: "fltSearchLogPerformanceApp/FULL_LOAD"
};
export {
  searchLogPerformanceConstants as default
};
//# sourceMappingURL=SearchLogPerformanceConstants.js.map
